import { Help } from '@mui/icons-material';
import { MenuItem, TextField } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { enumT } from '../../../../../utils/helper';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

const MUISelectField: React.FC<MUIFieldProps> = (props) => {
	const {
		label,
		hideLabel,
		tooltip,
		fieldValue,
		updateFieldValue,
		isDisabled,
		sortAlphabetically = true,
		error,
		errorMessage,
		hideCharacterLengthInfo,
		...restProps
	} = props;

	const shouldHideLabel = hideLabel && !tooltip;
	const sanitizedLabel = label.replace(/\s+/g, '-');

	let options = get(props, 'options', []).length > 0 ? get(props, 'options', []) : get(props, 'enum', []);
	if (sortAlphabetically) options.sort();

	return (
		<TextField
			fullWidth
			select
			id={`${sanitizedLabel}-input`}
			label={
				!shouldHideLabel ?
					<span>
						{label}
						{tooltip && (
							<MUIToolTip title={tooltip} id={`${label}-tooltip`}>
								<Help fontSize='small' color='primary' sx={{ ml: '5px' }} />
							</MUIToolTip>
						)}
					</span>
				:	undefined
			}
			value={
				typeof fieldValue === 'object' ?
					get(props, 'options', []).length > 0 ?
						fieldValue.id
					:	''
				:	fieldValue
			}
			onChange={updateFieldValue}
			disabled={isDisabled}
			error={error}
			helperText={error ? <span id={`${sanitizedLabel}-error-text`}>{errorMessage}</span> : undefined}
			inputProps={{
				...(shouldHideLabel ? { 'aria-label': label } : { 'aria-labelledby': `${sanitizedLabel}-input` }),
			}}
			SelectProps={{
				inputProps: {
					...(shouldHideLabel ? { 'aria-label': label } : { 'aria-labelledby': `${sanitizedLabel}-input` }),
				},
				MenuProps,
			}}
			{...restProps}
		>
			<MenuItem key='empty_value' value=''>
				&nbsp;
			</MenuItem>
			{options.map((ele: any, i: number) => {
				if (get(ele, 'label')) {
					return (
						<MenuItem key={i} value={get(ele, 'value')}>
							{get(ele, 'label')}
						</MenuItem>
					);
				} else {
					return (
						<MenuItem key={i} value={ele}>
							{enumT(ele)}
						</MenuItem>
					);
				}
			})}
		</TextField>
	);
};

export default MUISelectField;
